import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.home');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-home',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.home/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageHomeComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public popularSongs: any[] = [];
    public catalogTotal: number = 0;
    public approvedTotal: number = 0;
    public popularEmptyReason: string = '';

    public async ngOnInit() {
        await this.service.init();
        await this.loadPopular();
    }

    public async loadPopular() {
        try {
            let { code, data } = await wiz.call("popular");
            if (code === 200) {
                this.popularSongs = data.songs || [];
                this.catalogTotal = data.catalog_total || 0;
                this.approvedTotal = data.approved_total || 0;
                this.popularEmptyReason = data.empty_reason || '';
            }
        } catch (e) { }
        await this.service.render();
    }

    public getPopularEmptyTitle(): string {
        if (this.popularEmptyReason === 'no_catalog') return '곡 데이터베이스가 비어 있습니다';
        if (this.popularEmptyReason === 'no_approved') return '승인된 곡이 아직 없습니다';
        return '인기곡을 준비 중입니다';
    }

    public getPopularEmptyHint(): string {
        if (this.popularEmptyReason === 'no_catalog') return '관리자에서 샘플 데이터를 추가하거나 CSV로 곡을 업로드하세요.';
        if (this.popularEmptyReason === 'no_approved') return '등록된 곡을 승인하면 추천과 검색에 표시됩니다.';
        return '곡 이용 데이터가 쌓이면 여기에 표시됩니다.';
    }

    public goTest() { this.service.href('/test'); }
    public goRecommend() { this.service.href('/recommend'); }
    public goPractice() { this.service.href('/practice'); }
    public goAdminSongs() { this.service.href('/admin/songs'); }
}

export default PageHomeComponent;